import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, of as observableOf } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { CONFIG_ENV_JSON_PATH, CONFIG_ENV_HMG_JSON_PATH } from '../constants/config.constants';
/**
 * Serviço responsável por trazer as configurações
 * de `/config/env.json`
 * (local das configurações por ambiente.)
 */
@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  /**
   * Chave para ser usada como
   * identificaçõe da app rodando
   */
  appKey: string;

  /**
   * Cache das configurações
   */
  private cache: Map<string, any> = new Map();

  /**
   * Inicializador da classe
   * @param httpClient Cliente para as requisiçõe HTTP
   */
  constructor(
    private httpClient: HttpClient
  ) {
      this.appKey = 'cmd-1';
  }

  /**
   * Registra nas configurações para fins de cache
   * qual aplicação em questão
   * @param name Nome da aplicação
   * @param version Versão da aplicação
   */
  registerApp(name: string, version: string): void {
    console.log('%cRegistrando aplicação: %s (%s)', 'color: #fafafa; background: #424242', name, version);
    this.appKey = `app:${name}|version:${version}`;
  }

  /**
   * Retorna um `Observable`. Se assinado vai
   * trazer todas as configurações em
   * um objeto só
   */
  getAll(): Observable<any> {
    if (this.cache.has(this.appKey)) {
      return observableOf(this.cache.get(this.appKey));
    } else {
      const env = CONFIG_ENV_JSON_PATH;
      return this.httpClient.get<any>(env).pipe(
        take(1),
        tap((config: any) => this.cache.set(this.appKey, config)),
      );
    }
  }

  /**
   * Retorna um `Observable`. Se assinado vai
   * trazer a configuração selecionada
   * @param property Propriedade da configuração a ser retornada no `Observable`
   */
  get(property: string): Observable<any> {
    return this.getAll().pipe(
      map((config: any) => config[property] as any)
    ).pipe(take(1));
  }

  /**
   * Retorna um `Observable`. Se assinado vai
   * trazer as configurações selecionadas
   * em uma lista
   * @param properties Lista de propriedades da configuração a serem retornadas no `Observable`
   */
  getList(properties: string[]): Observable<any[]> {
    return forkJoin(
      properties.map((property: string) => this.get(property))
    ).pipe(take(1));
  }
}
